import {
    SET_PROCESS_STARTED,
    SET_AUTHORIZING,
    SET_AUTHORIZATION_FAILED,
    SET_REFRESH,
    SET_STARTING,
    SET_TEXTS,
} from './constants'

export function setProcessStartedText(text) {
    return {
        type: SET_PROCESS_STARTED,
        payload: text,
    }
}

export function setAuthorizingText(text) {
    return {
        type: SET_AUTHORIZING,
        payload: text,
    }
}

export function setAuthorizationFailedText(text) {
    return {
        type: SET_AUTHORIZATION_FAILED,
        payload: text,
    }
}

export function setRefreshText(text) {
    return {
        type: SET_REFRESH,
        payload: text,
    }
}

export function setStartingText(text) {
    return {
        type: SET_STARTING,
        payload: text,
    }
}

export function setTexts(texts) {
    return {
        type: SET_TEXTS,
        payload: texts,
    }
}



// WEBPACK FOOTER //
// ./src/features/LaunchProgressBar/data/texts/actions.js